import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const circling = keyframes`
0%,
100% {
    box-shadow: 0 -2.6em 0 0 #279BE4, 1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2), 2.5em 0 0 0 rgba(39, 155, 228, 0.2), 1.75em 1.75em 0 0 rgba(39, 155, 228, 0.2), 0 2.5em 0 0 rgba(39, 155, 228, 0.2), -1.8em 1.8em 0 0 rgba(39, 155, 228, 0.2), -2.6em 0 0 0 rgba(39, 155, 228, 0.5), -1.8em -1.8em 0 0 rgba(39, 155, 228, 0.7);
}
12.5% {
    box-shadow: 0 -2.6em 0 0 rgba(39, 155, 228, 0.7), 1.8em -1.8em 0 0 #279BE4, 2.5em 0 0 0 rgba(39, 155, 228, 0.2), 1.75em 1.75em 0 0 rgba(39, 155, 228, 0.2), 0 2.5em 0 0 rgba(39, 155, 228, 0.2), -1.8em 1.8em 0 0 rgba(39, 155, 228, 0.2), -2.6em 0 0 0 rgba(39, 155, 228, 0.2), -1.8em -1.8em 0 0 rgba(39, 155, 228, 0.5);
}
25% {
    box-shadow: 0 -2.6em 0 0 rgba(39, 155, 228, 0.5), 1.8em -1.8em 0 0 rgba(39, 155, 228, 0.7), 2.5em 0 0 0 #279BE4, 1.75em 1.75em 0 0 rgba(39, 155, 228, 0.2), 0 2.5em 0 0 rgba(39, 155, 228, 0.2), -1.8em 1.8em 0 0 rgba(39, 155, 228, 0.2), -2.6em 0 0 0 rgba(39, 155, 228, 0.2), -1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2);
}
37.5% {
    box-shadow: 0 -2.6em 0 0 rgba(39, 155, 228, 0.2), 1.8em -1.8em 0 0 rgba(39, 155, 228, 0.5), 2.5em 0 0 0 rgba(39, 155, 228, 0.7), 1.75em 1.75em 0 0 #279BE4, 0 2.5em 0 0 rgba(39, 155, 228, 0.2), -1.8em 1.8em 0 0 rgba(39, 155, 228, 0.2), -2.6em 0 0 0 rgba(39, 155, 228, 0.2), -1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2);
}
50% {
    box-shadow: 0 -2.6em 0 0 rgba(39, 155, 228, 0.2), 1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2), 2.5em 0 0 0 rgba(39, 155, 228, 0.5), 1.75em 1.75em 0 0 rgba(39, 155, 228, 0.7), 0 2.5em 0 0 #279BE4, -1.8em 1.8em 0 0 rgba(39, 155, 228, 0.2), -2.6em 0 0 0 rgba(39, 155, 228, 0.2), -1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2);
}
62.5% {
    box-shadow: 0 -2.6em 0 0 rgba(39, 155, 228, 0.2), 1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2), 2.5em 0 0 0 rgba(39, 155, 228, 0.2), 1.75em 1.75em 0 0 rgba(39, 155, 228, 0.5), 0 2.5em 0 0 rgba(39, 155, 228, 0.7), -1.8em 1.8em 0 0 #279BE4, -2.6em 0 0 0 rgba(39, 155, 228, 0.2), -1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2);
}
75% {
    box-shadow: 0 -2.6em 0 0 rgba(39, 155, 228, 0.2), 1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2), 2.5em 0 0 0 rgba(39, 155, 228, 0.2), 1.75em 1.75em 0 0 rgba(39, 155, 228, 0.2), 0 2.5em 0 0 rgba(39, 155, 228, 0.5), -1.8em 1.8em 0 0 rgba(39, 155, 228, 0.7), -2.6em 0 0 0 #279BE4, -1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2);
}
87.5% {
    box-shadow: 0 -2.6em 0 0 rgba(39, 155, 228, 0.2), 1.8em -1.8em 0 0 rgba(39, 155, 228, 0.2), 2.5em 0 0 0 rgba(39, 155, 228, 0.2), 1.75em 1.75em 0 0 rgba(39, 155, 228, 0.2), 0 2.5em 0 0 rgba(39, 155, 228, 0.2), -1.8em 1.8em 0 0 rgba(39, 155, 228, 0.5), -2.6em 0 0 0 rgba(39, 155, 228, 0.7), -1.8em -1.8em 0 0 #279BE4;
}
`;

export const LoadingIcon = styled.div({
    margin: '-5px',
    fontSize: '10px',
    width: '1em',
    height: '1em',
    borderRadius: '50%',
    animationName: circling,
    animationDuration: '1.1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease',
});
